module.exports = __webpack_public_path__ + "img/emitus-logo-gray.d6e39819.svg";